/* eslint-disable react/prop-types */
/**
 * @file PowerDisconnectedDefault.jsx
 * @exports PowerDisconnectedDefault
 */
import React from 'react'

const defaultColor = '#284047'

const PowerDisconnectedDefault = function PowerDisconnectedDefault ({ boltColor, circleColor, style }) {
  return (<PowerDisconnected boltColor={boltColor} circleColor={circleColor} style={style} />)
}

export default PowerDisconnectedDefault

const PowerDisconnected = function PowerDisconnected ({ boltColor, circleColor, style }) {
  return (
    <svg id='power-disconnected-icon' viewBox='0 0 75 75'>
      <title>power disconnected icon</title>
      <g
        style={{
          transform: 'translate(13px, 13px) scale(2)',
        }}
      >
        <path
          id='lightning-bolt'
          d='M 18.8,9.9 8.3,20.4 c -0.1,0.1 -0.2,0.1 -0.3,0.1 -0.1,0 -0.2,0 -0.3,-0.1 -0.2,-0.1 -0.2,-0.4 -0.1,-0.6 l 3.3,-7.1 H 6.25 c -0.3,0 -0.5,-0.2 -0.5,-0.5 0,-0.1 0,-0.2 0.1,-0.2 l 4.1,-7.8 c 0.1,-0.2 0.2,-0.3 0.4,-0.3 h 5.3 c 0.3,0 0.5,0.2 0.5,0.5 0,0.1 0,0.2 -0.1,0.2 l -2.4,4.3 h 4.7 c 0.3,0 0.5,0.2 0.5,0.5 0,0.3 0,0.4 -0.1,0.5 z'
          style={{ ...style, fill: boltColor || defaultColor }}
        />
        <rect
          transform='rotate(-38.7)'
          x='-9.5'
          y='16.1'
          width='21.7'
          height='1.3'
          style={{ ...style, fill: circleColor || defaultColor, stroke: 'white', strokeWidth: 0.25 }}
        />
        <circle
          cx='11.7'
          cy='12.4'
          r='10.9'
          style={{ ...style, fill: 'none', stroke: circleColor || defaultColor, strokeWidth: 1.5 }}
        />
      </g>
    </svg>
  )
}
